import style from "assets/jss/material-dashboard-pro-react/views/createWireTransferStyle.jsx";
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import { withArtifex } from "core";
import PropTypes from "prop-types";
import React, { Component } from "react";
import { GenericNumberInput, GenericSelectInput, GenericTextInput, GenericDateInput } from "views/Components/Generic";
import DateHelper from "core/DateHelper";
import moment from "moment";

class IncomingWireDetail extends Component {
   constructor(props) {
      super(props);

      this.EmptyObject = {};
   }

   RenderCountry = (d) => `${d.ISO2} - ${d.Name}`;
   RenderAccount = (x) => `${x.AccountNumber} - ${x.AccountName}`;

   render() {
      const { ReceiverModel, ReceiverInfo, BeneficiaryInfo, Model, ValueChanged, IsBackOffice, IsUpdating } =
         this.props;

      console.log("Account Number:", Model.AccountNumber);
      return (
         <GridContainer>
            <GridItem xs={4}>
               <GridContainer>
                  <GridItem xs={12}>
                     <h4 style={{ color: "black", textAlign: "center" }}>
                        <b>Beneficiary Information</b>
                     </h4>
                  </GridItem>
                  <GridItem xs={12}>
                     <GenericTextInput
                        LabelText="Beneficiary Client Name"
                        Value={BeneficiaryInfo.LegalName}
                        Disabled={true}
                     />
                  </GridItem>
                  <GridItem xs={12}>
                     {IsUpdating ? (
                        <GenericSelectInput
                           Name="AccountNumber"
                           LabelText="Beneficiary Account Number"
                           Required={true}
                           KeyValueMember="AccountNumber"
                           IsStatic
                           StaticData={BeneficiaryInfo.Accounts}
                           TextValueMember="AccountNumber"
                           RenderItem={this.RenderAccount}
                           Value={Model.AccountNumber}
                           ValueChanged={ValueChanged}
                           Disabled={IsBackOffice}
                        />
                     ) : (
                        <GenericTextInput
                           LabelText="Beneficiary Account Number"
                           Value={Model.AccountNumber}
                           Disabled={true}
                        />
                     )}
                  </GridItem>
                  <GridItem xs={12}>
                     <GenericTextInput
                        LabelText="Beneficiary Address Line 1"
                        Value={BeneficiaryInfo.AddressLine1}
                        Disabled={true}
                     />
                  </GridItem>
                  <GridItem xs={12}>
                     <GenericTextInput
                        LabelText="Beneficiary Address Line 2"
                        Value={BeneficiaryInfo.AddressLine2}
                        Disabled={true}
                     />
                  </GridItem>
                  <GridItem xs={12}>
                     <GenericTextInput
                        LabelText="Beneficiary Postal Code"
                        Value={BeneficiaryInfo.ZipCode}
                        Disabled={true}
                     />
                  </GridItem>
                  <GridItem xs={12}>
                     <GenericTextInput LabelText="Beneficiary City" Value={BeneficiaryInfo.CityName} Disabled={true} />
                  </GridItem>
                  <GridItem xs={12}>
                     <GenericTextInput
                        LabelText="Beneficiary Province"
                        Value={BeneficiaryInfo.ProvinceName}
                        Disabled={true}
                     />
                  </GridItem>
                  <GridItem xs={12}>
                     <GenericTextInput
                        LabelText="Beneficiary Country"
                        Value={BeneficiaryInfo.CountryName}
                        Disabled={true}
                     />
                  </GridItem>
                  <GridItem xs={12}>
                     <GenericTextInput LabelText="Entity Type" Value={BeneficiaryInfo.EntityType} Disabled={true} />
                  </GridItem>
                  <GridItem xs={12}>
                     <GenericTextInput
                        LabelText="Entity Identifier Type"
                        Value={BeneficiaryInfo.IdentifierType}
                        Disabled={true}
                     />
                  </GridItem>
                  <GridItem xs={12}>
                     <GenericTextInput
                        LabelText="Entity Document Number"
                        Value={BeneficiaryInfo.DocumentNumber}
                        Disabled={true}
                     />
                  </GridItem>
                  <GridItem xs={12}>
                     <GenericTextInput
                        LabelText="Entity Province Of Registration"
                        Value={BeneficiaryInfo.ProvinceOfRegistration}
                        Disabled={true}
                     />
                  </GridItem>
                  <GridItem xs={12}>
                     <GenericTextInput
                        LabelText="Entity Country Of Registration"
                        Value={BeneficiaryInfo.CountryOfRegistration}
                        Disabled={true}
                     />
                  </GridItem>
               </GridContainer>
            </GridItem>
            <GridItem xs={4}>
               <GridContainer>
                  <GridItem xs={12}>
                     <h4 style={{ color: "black", textAlign: "center" }}>
                        <b>Receiver Information</b>
                     </h4>
                  </GridItem>
                  <GridItem xs={12}>
                     {IsUpdating ? (
                        <GenericSelectInput
                           Name="WireIncomingBeneficiaryId"
                           LabelText="Receiver"
                           Required={true}
                           KeyValueMember="Id"
                           IsStatic
                           StaticData={ReceiverInfo}
                           TextValueMember="Alias"
                           Value={Model.WireIncomingBeneficiaryId}
                           ValueChanged={ValueChanged}
                        />
                     ) : (
                        <GenericTextInput LabelText="Receiver" Value={ReceiverModel?.Alias} Disabled={true} />
                     )}
                  </GridItem>
                  <GridItem xs={12}>
                     <GenericTextInput LabelText="Receiver Name" Value={ReceiverModel?.ReceiverName} Disabled={true} />
                  </GridItem>
                  <GridItem xs={12}>
                     <GenericTextInput
                        LabelText="Receiver Address Line 1"
                        Value={ReceiverModel?.ReceiverAddress1}
                        Disabled={true}
                     />
                  </GridItem>
                  <GridItem xs={12}>
                     <GenericTextInput
                        LabelText="Receiver Address Line 2"
                        Value={ReceiverModel?.ReceiverAddress2}
                        Disabled={true}
                     />
                  </GridItem>
                  <GridItem xs={12}>
                     <GenericTextInput LabelText="Receiver City" Value={ReceiverModel?.ReceiverCity} Disabled={true} />
                  </GridItem>
                  <GridItem xs={12}>
                     <GenericTextInput
                        LabelText="Receiver Province"
                        Value={ReceiverModel?.ReceiverProvince}
                        Disabled={true}
                     />
                  </GridItem>
                  <GridItem xs={12}>
                     <GenericTextInput
                        LabelText="Receiver Country"
                        Value={ReceiverModel?.ReceiverCountry}
                        Disabled={true}
                     />
                  </GridItem>
                  <GridItem xs={12}>
                     <GenericTextInput
                        LabelText="Receiver Postal Code"
                        Value={ReceiverModel?.ReceiverPostalCode}
                        Disabled={true}
                     />
                  </GridItem>
                  <GridItem xs={12}>
                     <GenericTextInput
                        LabelText="Receiver Account Number"
                        Value={ReceiverModel?.ReceiverAccountNumber}
                        Disabled={true}
                     />
                  </GridItem>
                  <GridItem xs={12}>
                     <GenericTextInput LabelText="Receiver SWIFT" Value={ReceiverModel?.ReceiverSWIFT} Disabled={true} />
                  </GridItem>
                  <GridItem xs={12}>
                     <GenericTextInput LabelText="Receiver FI" Value={ReceiverModel?.ReceiverFI} Disabled={true} />
                  </GridItem>
                  <GridItem xs={12}>
                     <GenericTextInput
                        LabelText="Receiver FI Branch"
                        Value={ReceiverModel?.ReceiverFITransitNumber}
                        Disabled={true}
                     />
                  </GridItem>
                  <GridItem xs={12}>
                     <GenericTextInput
                        LabelText="Receiver FI Address 1"
                        Value={ReceiverModel?.ReceiverFIAddress1}
                        Disabled={true}
                     />
                  </GridItem>
                  <GridItem xs={12}>
                     <GenericTextInput
                        LabelText="Receiver FI Address 2"
                        Value={ReceiverModel?.ReceiverFIAddress2}
                        Disabled={true}
                     />
                  </GridItem>
                  <GridItem xs={12}>
                     <GenericTextInput
                        LabelText="Receiver FI City"
                        Value={ReceiverModel?.ReceiverFICity}
                        Disabled={true}
                     />
                  </GridItem>
                  <GridItem xs={12}>
                     <GenericTextInput
                        LabelText="Receiver FI Province"
                        Value={ReceiverModel?.ReceiverFIProvince}
                        Disabled={true}
                     />
                  </GridItem>
                  <GridItem xs={12}>
                     <GenericTextInput
                        LabelText="Receiver FI Country"
                        Value={ReceiverModel?.ReceiverFICountry}
                        Disabled={true}
                     />
                  </GridItem>
                  <GridItem xs={12}>
                     <GenericTextInput
                        LabelText="Receiver FI Postal Code"
                        Value={ReceiverModel?.ReceiverFIPostalCode}
                        Disabled={true}
                     />
                  </GridItem>
               </GridContainer>
            </GridItem>
            <GridItem xs={4}>
               <GridContainer>
                  <GridItem xs={12}>
                     <h4 style={{ color: "black" }}>
                        <b>Ordering Client Information</b>
                     </h4>
                  </GridItem>
                  <GridItem xs={12}>
                     <GenericTextInput
                        Name="OrderingClientName"
                        LabelText="Ordering Client Name"
                        Value={Model.OrderingClientName}
                        ValueChanged={ValueChanged}
                        Disabled={!IsUpdating}
                        inputProps={{ maxLength: 256 }}
                        Required={IsUpdating}
                     />
                  </GridItem>
                  <GridItem xs={12}>
                     <GenericSelectInput
                        Name="OrderingCountryId"
                        LabelText="Ordering Country"
                        Method="POST"
                        Url="/bankapi/v1.0/WireTransfer/GetWireCountries"
                        Parameter={{}}
                        DataRoot="Item"
                        KeyValueMember="Id"
                        TextValueMember="Code"
                        Value={Model.OrderingCountryId}
                        ValueChanged={ValueChanged}
                        Sorted={{ Member: "OrderIndex" }}
                        RenderItem={this.RenderCountry}
                        Disabled={!IsUpdating}
                        Required={IsUpdating}
                     />
                  </GridItem>
                  <GridItem xs={12}>
                     <GenericSelectInput
                        key={Model.OrderingCountryId + "province"}
                        Name="OrderingProvinceId"
                        LabelText="Ordering Province"
                        Method="POST"
                        Url="/bankapi/v1.0/WireTransfer/GetWireProvinces"
                        Parameter={{ Id: Model.OrderingCountryId ?? 0 }}
                        DataRoot="Item"
                        KeyValueMember="Id"
                        TextValueMember="Name"
                        Value={Model.OrderingProvinceId}
                        ValueChanged={ValueChanged}
                        Sorted={{ Member: "Name" }}
                        Disabled={!IsUpdating}
                        Required={IsUpdating}
                     />
                  </GridItem>
                  <GridItem xs={12}>
                     <GenericSelectInput
                        VirtualizedList
                        key={"city" + Model.OrderingProvinceId + "" + Model.OrderingCountryId}
                        Name="OrderingCityId"
                        LabelText="Ordering City"
                        Method="POST"
                        Url="/bankapi/v1.0/WireTransfer/GetWireCities"
                        Parameter={{ Id: Model.OrderingProvinceId ?? 0 }}
                        DataRoot="Item"
                        KeyValueMember="Id"
                        TextValueMember="Name"
                        Value={Model.OrderingCityId}
                        ValueChanged={ValueChanged}
                        Sorted={{ Member: "Name" }}
                        Disabled={!IsUpdating}
                        Required={IsUpdating}
                     />
                  </GridItem>
                  <GridItem xs={12}>
                     <GenericTextInput
                        Name="OrderingAddressLine1"
                        LabelText="Ordering Address Line 1"
                        Id="ordering-street-address1"
                        Value={Model.OrderingAddressLine1}
                        ValueChanged={ValueChanged}
                        Disabled={!IsUpdating}
                        inputProps={{ maxLength: 256 }}
                        Required={IsUpdating}
                     />
                  </GridItem>
                  <GridItem xs={12}>
                     <GenericTextInput
                        Name="OrderingAddressLine2"
                        LabelText="Ordering Address Line 2"
                        Id="ordering-street-address2"
                        Value={Model.OrderingAddressLine2}
                        ValueChanged={ValueChanged}
                        Disabled={!IsUpdating}
                        inputProps={{ maxLength: 256 }}
                     />
                  </GridItem>
                  <GridItem xs={12}>
                     <GenericTextInput
                        Name="OrderingZipCode"
                        LabelText="Ordering Postal Code"
                        Id="ordering-postcode"
                        Value={Model.OrderingZipCode}
                        ValueChanged={ValueChanged}
                        Disabled={!IsUpdating}
                        inputProps={{ maxLength: 20 }}
                        Required={IsUpdating}
                     />
                  </GridItem>
                  <GridItem xs={12}>
                     <GenericTextInput
                        Name="OrderingSourceAccountNumber"
                        LabelText="Ordering Source Account Number"
                        Value={Model.OrderingSourceAccountNumber}
                        ValueChanged={ValueChanged}
                        Disabled={!IsUpdating}
                        inputProps={{ maxLength: 50 }}
                        Required={IsUpdating}
                     />
                  </GridItem>
                  <GridItem xs={12}>
                     <br />
                     <h4 style={{ color: "black", textAlign: "center" }}>
                        <b>Sending Financial Institution Information</b>
                     </h4>
                  </GridItem>
                  <GridItem xs={12}>
                     <GenericSelectInput
                        Name="InternationalBankCountryId"
                        LabelText="International Bank Country"
                        Method="POST"
                        Url="/bankapi/v1.0/WireTransfer/GetWireCountries"
                        Parameter={{}}
                        DataRoot="Item"
                        KeyValueMember="Id"
                        TextValueMember="Code"
                        Value={Model.InternationalBankCountryId}
                        ValueChanged={ValueChanged}
                        Sorted={{ Member: "OrderIndex" }}
                        RenderItem={this.RenderCountry}
                        Disabled={!IsUpdating}
                        Required={IsUpdating}
                     />
                  </GridItem>
                  <GridItem xs={12}>
                     <GenericTextInput
                        Name="SendingFI"
                        LabelText="Sending Financial Institution"
                        Value={Model.SendingFI}
                        ValueChanged={ValueChanged}
                        Disabled={!IsUpdating}
                        inputProps={{ maxLength: 50 }}
                        Required={IsUpdating}
                     />
                  </GridItem>
                  <GridItem xs={12}>
                     <GenericTextInput
                        Name="SendingFISwiftCode"
                        LabelText="Sending FI Swift Code"
                        Value={Model.SendingFISwiftCode}
                        ValueChanged={ValueChanged}
                        Disabled={!IsUpdating}
                        inputProps={{ maxLength: 50 }}
                        Required={IsUpdating}
                     />
                  </GridItem>
                  <GridItem xs={12}>
                     <GenericTextInput
                        Name="SendingFIAddress"
                        LabelText="Sending FI Address"
                        Value={Model.SendingFIAddress}
                        ValueChanged={ValueChanged}
                        Disabled={!IsUpdating}
                        inputProps={{ maxLength: 256 }}
                        Required={IsUpdating}
                     />
                  </GridItem>
                  <GridItem xs={12}>
                     <GenericSelectInput
                        Name="SendingFICountryId"
                        LabelText="Sending FI Country"
                        Method="POST"
                        Url="/bankapi/v1.0/WireTransfer/GetWireCountries"
                        Parameter={{}}
                        DataRoot="Item"
                        KeyValueMember="Id"
                        TextValueMember="Code"
                        Value={Model.SendingFICountryId}
                        ValueChanged={ValueChanged}
                        Sorted={{ Member: "OrderIndex" }}
                        RenderItem={this.RenderCountry}
                        Disabled={!IsUpdating}
                        Required={IsUpdating}
                     />
                  </GridItem>
               </GridContainer>
            </GridItem>
            <GridItem xs={8}>
               <GridContainer>
                  <GridItem xs={12}>
                     <br />
                     <h4 style={{ color: "black", textAlign: "center" }}>
                        <b>Incoming Transfer Detail</b>
                     </h4>
                  </GridItem>
                  <GridItem xs={6}>
                     <GenericDateInput
                        Name="WireTransactionDate"
                        LabelText="Wire Transaction Date"
                        Value={
                           Model.WireTransactionDate ? moment(Model.WireTransactionDate) : DateHelper.GetDateLocal()
                        }
                        ValueChanged={ValueChanged}
                        DateFormat={"DD MMMM YYYY"}
                        MaxDate={DateHelper.GetDateLocal()}
                        Disabled={!IsUpdating}
                        Required={IsUpdating}
                     />
                  </GridItem>
                  {Model.BackOfficeApprovedDateTime ? (
                     <GridItem xs={6}>
                        <GenericDateInput
                           Name="ApprovalDate"
                           LabelText="Approval Date"
                           Value={moment(Model.BackOfficeApprovedDateTime)}
                           DateFormat={"DD MMMM YYYY"}
                           Disabled={true}
                        />
                     </GridItem>
                  ) : (
                     <GridItem xs={6} />
                  )}
                  <GridItem xs={6}>
                     <GenericNumberInput
                        Name="Amount"
                        LabelText="Amount"
                        Value={Model.Amount}
                        ValueChanged={ValueChanged}
                        Disabled={!IsUpdating}
                        Prefix={Model.AmountPrefix}
                        Required={IsUpdating}
                        MaxLength={10}
                     />
                  </GridItem>
                  <GridItem xs={6}>
                     <GenericSelectInput
                        Disabled={true}
                        Name="CurrencyId"
                        LabelText="Currency"
                        Value={Model.CurrencyId || "CAD"}
                        KeyValueMember="Id"
                        TextValueMember="Description"
                        Method="GET"
                        Url="/bankapi/v1.0/Currency/ValidCurrencies"
                        DefaultIndex={0}
                        RenderItem={(d) => d.Code + " - " + d.Description}
                        ValueChanged={ValueChanged}
                        DataRoot="Item"
                     />
                  </GridItem>
                  <GridItem xs={6}>
                     <GenericTextInput
                        Name="WireReferenceNumber"
                        LabelText="Wire Reference Number"
                        Value={Model.WireReferenceNumber}
                        ValueChanged={ValueChanged}
                        Disabled={!IsUpdating}
                        inputProps={{ maxLength: 60 }}
                     />
                  </GridItem>
                  <GridItem xs={6}>
                     <GenericTextInput
                        Name="WirePurpose"
                        LabelText="Purpose Of Wire"
                        Value={Model.WirePurpose}
                        ValueChanged={ValueChanged}
                        Disabled={!IsUpdating}
                        Required={IsUpdating}
                        inputProps={{ maxLength: 256 }}
                     />
                  </GridItem>
               </GridContainer>
            </GridItem>
         </GridContainer>
      );
   }
}

IncomingWireDetail.propTypes = {
   classes: PropTypes.object.isRequired,
   ValueChanged: PropTypes.func,
   IsBackOffice: PropTypes.any,
   Disabled: PropTypes.bool,
   ClientInfo: PropTypes.any,
   ReceiverInfo: PropTypes.any,
   ReceiverModel: PropTypes.any,
   BeneficiaryInfo: PropTypes.any,
   Model: PropTypes.any,
   IsUpdating: PropTypes.bool,
};

export default withArtifex(IncomingWireDetail, style);